import type { CSSProperties } from 'react';
import { colorWithAlpha } from '@/utils/colorWithAlpha';

export function getAuthInputStyles(accentColor: string) {
  const focusRing = colorWithAlpha(accentColor, 0.35);

  return {
    label: {
      marginBottom: 6,
      fontSize: '0.8125rem',
      fontWeight: 500,
      color: 'var(--mantine-color-dimmed)',
    },
    input: {
      height: 42,
      borderRadius: 8,
      borderColor: 'var(--mantine-color-default-border)',
      backgroundColor: 'var(--mantine-color-body)',
      fontSize: '0.875rem',
      transition: 'border-color 0.18s ease, box-shadow 0.18s ease',
      '&:focus': {
        borderColor: accentColor,
        boxShadow: `0 0 0 3px ${focusRing}`,
      },
    },
    section: {
      color: 'var(--mantine-color-dimmed)',
    },
  };
}

export function getAuthPageStyle(accentColor: string): CSSProperties {
  return { '--auth-accent': accentColor } as CSSProperties;
}
